var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal-3",
    {
      attrs: {
        id_modal: "modal_convenio_federal_detalhe",
        class_modal: "modal-lg shadow",
        backdrop: "static",
      },
      on: { opened: _vm.onOpened, closed: _vm.onClosed },
      scopedSlots: _vm._u([
        {
          key: "header",
          fn: function () {
            return [
              _c(
                "span",
                {
                  staticClass:
                    "m-0 px-2 mr-auto text-muted font-weight-normal font-size-07 d-flex align-items-center",
                  attrs: { id: "titulo_modal_convenio_federal_detalhe" },
                },
                [
                  _vm.convenio && _vm.convenio.id_convenio_portal
                    ? _c("span", [
                        _vm._v(_vm._s(_vm.convenio.id_convenio_portal)),
                      ])
                    : _vm._e(),
                ]
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _vm.carregando
        ? _c(
            "div",
            { staticClass: "text-center py-5" },
            [
              _c("hollow-dots-spinner", {
                staticStyle: { display: "inline-block" },
                attrs: {
                  "animation-duration": 1000,
                  "dot-size": 10,
                  "dots-num": 3,
                  color: "#6F787D",
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "mt-2 small text-muted" }, [
                _vm._v("Carregando convênio..."),
              ]),
            ],
            1
          )
        : _vm.erro
        ? _c(
            "div",
            {
              staticClass:
                "alert alert-danger d-flex align-items-center justify-content-between",
              attrs: { role: "alert" },
            },
            [
              _c("div", [
                _c("i", { staticClass: "fas fa-exclamation-triangle mr-2" }),
                _vm._v("\n            " + _vm._s(_vm.erro) + "\n        "),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-sm btn-outline-danger",
                  attrs: {
                    type: "button",
                    "aria-label": "Tentar carregar novamente",
                  },
                  on: { click: _vm.fetchDetalhe },
                },
                [
                  _c("i", { staticClass: "fas fa-redo mr-1" }),
                  _vm._v(" Tentar novamente\n        "),
                ]
              ),
            ]
          )
        : _vm.convenio
        ? _c("div", [
            _c(
              "section",
              {
                staticClass: "mb-3",
                attrs: { "aria-labelledby": "cf-secao-dados" },
              },
              [
                _c(
                  "h6",
                  {
                    staticClass: "text-uppercase small text-muted mb-2",
                    attrs: { id: "cf-secao-dados" },
                  },
                  [_vm._v("Dados do convênio")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-6 mb-2" }, [
                    _c("small", { staticClass: "text-muted d-block" }, [
                      _vm._v("Nº do convênio"),
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.convenio.numero_convenio || "—")),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-6 mb-2" }, [
                    _c("small", { staticClass: "text-muted d-block" }, [
                      _vm._v("Situação"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "badge",
                        class: _vm.badgeSituacaoClass(_vm.convenio.situacao),
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.convenio.situacao || "N/I") +
                            "\n                    "
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12 mb-2" }, [
                    _c("small", { staticClass: "text-muted d-block" }, [
                      _vm._v("Objeto"),
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.convenio.objeto || "—"))]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-6 mb-2" }, [
                    _c("small", { staticClass: "text-muted d-block" }, [
                      _vm._v("Concedente (CNPJ)"),
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.formatarCnpj(_vm.convenio.cnpj_concedente))
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-6 mb-2" }, [
                    _c("small", { staticClass: "text-muted d-block" }, [
                      _vm._v("Concedente (nome)"),
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.convenio.nome_concedente || "—")),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-6 mb-2" }, [
                    _c("small", { staticClass: "text-muted d-block" }, [
                      _vm._v("Convenente (CNPJ)"),
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.formatarCnpj(_vm.convenio.cnpj_convenente))
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-6 mb-2" }, [
                    _c("small", { staticClass: "text-muted d-block" }, [
                      _vm._v("Convenente (nome)"),
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.convenio.nome_convenente || "—")),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-4 mb-2" }, [
                    _c("small", { staticClass: "text-muted d-block" }, [
                      _vm._v("Valor global"),
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.formatarReal(_vm.convenio.valor_global))
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-4 mb-2" }, [
                    _c("small", { staticClass: "text-muted d-block" }, [
                      _vm._v("Valor repasse"),
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.formatarReal(_vm.convenio.valor_repasse))
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-4 mb-2" }, [
                    _c("small", { staticClass: "text-muted d-block" }, [
                      _vm._v("Valor contrapartida"),
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.formatarReal(_vm.convenio.valor_contrapartida)
                        )
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-4 mb-2" }, [
                    _c("small", { staticClass: "text-muted d-block" }, [
                      _vm._v("Data publicação"),
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.formatarData(_vm.convenio.data_celebracao))
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-4 mb-2" }, [
                    _c("small", { staticClass: "text-muted d-block" }, [
                      _vm._v("Início vigência"),
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.formatarData(_vm.convenio.data_inicio_vigencia)
                        )
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-4 mb-2" }, [
                    _c("small", { staticClass: "text-muted d-block" }, [
                      _vm._v("Fim vigência"),
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.formatarData(_vm.convenio.data_fim_vigencia))
                      ),
                    ]),
                  ]),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "section",
              {
                staticClass: "mb-3",
                attrs: { "aria-labelledby": "cf-secao-anexos" },
              },
              [
                _c(
                  "h6",
                  {
                    staticClass: "text-uppercase small text-muted mb-2",
                    attrs: { id: "cf-secao-anexos" },
                  },
                  [_vm._v("Documentos anexos")]
                ),
                _vm._v(" "),
                !_vm.anexos.length
                  ? _c(
                      "div",
                      {
                        staticClass: "alert alert-warning mb-2 py-2 px-3 small",
                      },
                      [
                        _c("i", { staticClass: "fas fa-info-circle mr-1" }),
                        _vm._v(
                          "\n                Nenhum anexo. Faça upload do primeiro PDF abaixo.\n            "
                        ),
                      ]
                    )
                  : _c(
                      "ul",
                      { staticClass: "list-group list-group-flush mb-2" },
                      _vm._l(_vm.anexos, function (anexo) {
                        return _c(
                          "li",
                          {
                            key: anexo.id_anexo,
                            staticClass:
                              "list-group-item d-flex align-items-center justify-content-between px-2 py-2",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "d-flex align-items-center",
                                staticStyle: { "min-width": "0" },
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "far fa-file-pdf text-danger mr-2 font-size-1",
                                  attrs: { "aria-hidden": "true" },
                                }),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass: "text-truncate",
                                    attrs: {
                                      href: anexo.url,
                                      target: "_blank",
                                      rel: "noopener noreferrer",
                                      title: anexo.name_file,
                                      "aria-label":
                                        "Abrir anexo " +
                                        anexo.name_file +
                                        " (nova aba)",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(anexo.name_file) +
                                        "\n                        "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "small",
                                  {
                                    staticClass:
                                      "text-muted ml-2 flex-shrink-0",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.formatarTamanho(anexo.size))
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-sm btn-outline-danger border-0 ml-2",
                                attrs: {
                                  type: "button",
                                  "aria-label":
                                    "Excluir anexo " + anexo.name_file,
                                  title: "Excluir " + anexo.name_file,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.excluir(anexo)
                                  },
                                },
                              },
                              [_c("i", { staticClass: "far fa-trash-alt" })]
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                _vm._v(" "),
                _c("upload-files", {
                  key: "upload_anexos_convenio_federal",
                  attrs: {
                    request: { post: "/anexos/upload" },
                    name_file: "arquivo_upload",
                    id_file: "upload_anexos_convenio_federal",
                    dados: _vm.dadosUpload,
                    drop_file: true,
                    edit_info: true,
                    img_size_limit: 104857600,
                    file_format: "^.*\\.pdf$",
                  },
                  on: { success: _vm.onUploadSuccess },
                }),
                _vm._v(" "),
                _c("small", { staticClass: "text-muted d-block mt-1" }, [
                  _vm._v("Apenas PDF, até 100 MB por arquivo."),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "footer",
              {
                staticClass:
                  "border-top pt-2 mt-2 small text-muted d-flex flex-wrap justify-content-between",
              },
              [
                _c("span", [
                  _vm._v(
                    "\n                Lista sincronizada em:\n                "
                  ),
                  _c("strong", [
                    _vm._v(
                      _vm._s(
                        _vm.formatarDataHora(_vm.convenio.lista_sincronizada_em)
                      )
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    "\n                Detalhe sincronizado em:\n                "
                  ),
                  _c("strong", [
                    _vm._v(
                      _vm._s(
                        _vm.formatarDataHora(
                          _vm.convenio.detalhe_sincronizado_em
                        )
                      )
                    ),
                  ]),
                ]),
              ]
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }